export default __webpack_public_path__ + "static/media/jenkins.65f8dc46.png";